<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('teams')" :icon="'briefcase'"/>
            </div>
            <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <button
                        v-if="$can('create_teams')"
                        type="button"
                        class="btn btn-primary btn-with-shadow"
                        data-toggle="modal"
                        @click="openTeamModal()">
                        {{ $fieldTitle('Add', $t('team'), true) }}
                    </button>
                </div>
            </div>
        </div>

        <app-overlay-loader v-if="preloader"/>
        <div v-else>
            <app-table
                id="team-table"
                :options="options"
                @action="triggerActions"
            />
        </div>

        <team-form-modal
            v-if="isTeamModalActive"
            v-model="isTeamModalActive"
            :selected-url="selectedUrl"
            :modal-id="'team-modal'"
        />

        <app-confirmation-modal
            :message="promptSubtitle"
            :modal-class="modalClass"
            :icon="promptIcon"
            v-if="confirmationModalActive"
            modal-id="app-confirmation-modal"
            @confirmed="changeStatus"
            @cancelled="cancelled"
        />

        <manage-team-users-modal
            v-if="isManageTeamUsersModalActive"
            v-model="isManageTeamUsersModalActive"
            :team="team"
        />
    </div>
</template>

<script>
import TeamMixin from "./TeamMixin";
import {axiosPost} from "../../../helpers/AxiosHelper";
import TeamFormModal from "./TeamFormModal";
import {TEAMS} from "../../../config/ApiUrl";
import ManageTeamUsersModal from "./ManageTeamUsersModal";

export default {
    name: "Teams",
    mixins: [TeamMixin],
    components: {TeamFormModal, ManageTeamUsersModal},
    data() {
        return {
            preloader: false,
            teamId: '',
            team: {},
            selectedUrl: '',
            modalClass: '',
            promptIcon: '',
            promptSubtitle: '',
            isTeamModalActive: false,
            confirmationModalActive: false,
            isManageTeamUsersModalActive: false,
        }
    },
    created() {
        this.$store.dispatch('getStatuses', 'team')
    },
    watch: {
        isTeamModalActive: function (value) {
            if (!value) {
                this.selectedUrl = '';
            }
        }
    },
    methods: {
        openTeamModal() {
            this.selectedUrl = '';
            this.isTeamModalActive = true;
        },
        changeStatus() {
            axiosPost(`${TEAMS}/${this.teamId}/update-status`).then(({data}) => {
                this.toastAndReload(data.message, 'team-table');
            }).catch(({response}) => {
                this.toastAndReload(response.data.message, 'team-table');
            }).finally(() => {
                this.confirmationModalActive = false;
            });
        },
        triggerActions(row, action, active) {
            this.teamId = row.id;
            this.team = row;
            this.promptIcon = action.icon;
            this.modalClass = action.modalClass;
            this.promptSubtitle = action.promptSubtitle;

            if (action.name === 'edit') {
                this.selectedUrl = `${action.url}/${row.id}`;
                this.isTeamModalActive = true;
            } else if (['deactivate', 'activate'].includes(action.key)) {
                this.confirmationModalActive = true;
            } else if (action.name === 'manage_users') {
                this.isManageTeamUsersModalActive = true
            } else {
                this.getAction(row, action, active)
            }
        }
    }
}
</script>
